import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    DijikolayState,
    DijikolayCustomer,
    DijikolayFilters,
    UpdateStatusPayload,
    UpdateContactedPayload,
    UpdateResponsiblePayload
} from './dijikolay.types';

const initialState: DijikolayState = {
    customers: {
        data: [],
        loading: false,
        error: null,
    },
    filters: {
        status: [],
        contacted: null
    },
    update: {
        loading: false,
        error: null,
    },
};

const dijikolaySlice = createSlice({
    name: 'dijikolay',
    initialState,
    reducers: {
        // --- Fetching Data ---
        fetchDijikolayCustomersRequest(state) {
            state.customers.loading = true;
            state.customers.error = null;
        },
        fetchDijikolayCustomersSuccess(state, action: PayloadAction<DijikolayCustomer[]>) {
            state.customers.loading = false;
            state.customers.data = action.payload;
        },
        fetchDijikolayCustomersFailure(state, action: PayloadAction<string>) {
            state.customers.loading = false;
            state.customers.error = action.payload;
        },

        // --- Filtering ---
        setDijikolayFilters(state, action: PayloadAction<Partial<DijikolayFilters>>) {
            state.filters = { ...state.filters, ...action.payload };
        },

        // --- Updating Data ---
        updateDijikolayStatusRequest(state, action: PayloadAction<UpdateStatusPayload>) {
            state.update.loading = true;
            state.update.error = null;
        },
        updateDijikolayContactedRequest(state, action: PayloadAction<UpdateContactedPayload>) {
            state.update.loading = true;
            state.update.error = null;
        },
        updateDijikolayResponsibleRequest(state, action: PayloadAction<UpdateResponsiblePayload>) {
            state.update.loading = true;
            state.update.error = null;
        },
        updateDijikolaySuccess(state, action: PayloadAction<DijikolayCustomer>) {
            state.update.loading = false;
            const updatedCustomer = action.payload;
            const index = state.customers.data.findIndex(c => c.id === updatedCustomer.id);
            if (index !== -1) {
                state.customers.data[index] = updatedCustomer;
            }
        },
        updateDijikolayFailure(state, action: PayloadAction<string>) {
            state.update.loading = false;
            state.update.error = action.payload;
        },
    },
});

export const {
    fetchDijikolayCustomersRequest,
    fetchDijikolayCustomersSuccess,
    fetchDijikolayCustomersFailure,
    setDijikolayFilters,
    updateDijikolayStatusRequest,
    updateDijikolayContactedRequest,
    updateDijikolayResponsibleRequest,
    updateDijikolaySuccess,
    updateDijikolayFailure,
} = dijikolaySlice.actions;

export default dijikolaySlice.reducer;